import { PixiComponent } from '@pixi/react';
import * as PIXI from 'pixi.js';
export const Rect = PixiComponent('Rect', {
    create: () => {
        return new PIXI.Graphics();
    },
    applyProps: (instance, oldProps, newProps) => {
        const { fillColor, fillAlpha, lineWidth, lineColor, lineAlpha, x, y, w, h, radius = 0, blendMode = PIXI.BLEND_MODES.NORMAL } = newProps;
        instance.clear();
        if (lineWidth && (lineColor !== undefined || fillColor !== undefined)) {
            instance.lineStyle(lineWidth, lineColor !== undefined ? lineColor : fillColor, lineAlpha !== undefined ? lineAlpha : undefined, 0);
        }
        instance.beginFill(fillColor, fillColor !== undefined ? fillAlpha : 0);
        if (radius) {
            instance.drawRoundedRect(x, y, w, h, radius);
        }
        else {
            instance.drawRect(x, y, w, h);
        }
        instance.blendMode = blendMode;
        instance.endFill();
    }
});
